import { ThemeConfig, ThemeMode } from '../entities';

const themeModes = new Set<unknown>(Object.values(ThemeMode));

const isThemeMode = (value: unknown): value is ThemeMode => themeModes.has(value);

export const getThemeMode = (themeConfig: ThemeConfig | null): ThemeMode => {
  const mode = themeConfig?.palette?.mode;

  return isThemeMode(mode) ? mode : ThemeMode.LIGHT;
};
